import { render, staticRenderFns } from "./HealthInsightsLink.vue?vue&type=template&id=722441c4&"
import script from "./HealthInsightsLink.vue?vue&type=script&lang=ts&"
export * from "./HealthInsightsLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports